import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { Subject } from 'rxjs';
import { ResultsViews, ResultTranslation, UI_SETTINGS } from '../../viewModels/abc-queries-editor.viewModel';
import { ResultsJsonComponent } from './results-json/results-json.component';
import { ResultsQueryJsonComponent } from './results-query-json/results-query-json.component';
import { ResultsQueryXmlComponent } from './results-query-xml/results-query-xml.component';
import { ResultsTableComponent } from './results-table/results-table.component';
import { ResultsXmlComponent } from './results-xml/results-xml.component';

@Component({
  selector: 'abc-opath-queries-editor-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
})
export class ResultsComponent implements OnInit, OnDestroy {
  @ViewChild(ResultsXmlComponent) resultsXmlComponent: ResultsXmlComponent;
  @ViewChild(ResultsTableComponent) resultsTableComponent: ResultsTableComponent;
  @ViewChild(ResultsJsonComponent) resultsJsonComponent: ResultsJsonComponent;
  @ViewChild(ResultsQueryXmlComponent) resultsQueryXmlComponent: ResultsQueryXmlComponent;
  @ViewChild(ResultsQueryJsonComponent) resultsQueryJsonComponent: ResultsQueryJsonComponent;

  public ResultsViews = ResultsViews;
  public resAsync: Promise<ResourceSet>;
  public currentView: ResultsViews;
  public uiSettings = UI_SETTINGS;
  @Input() public set currentResultsView(view: ResultsViews) {
    this.currentView = view;
  }
  public get currentResultsView(): ResultsViews {
    return this.currentView;
  }
  @Input() autoExec: boolean = true;
  @Input() resultsEmpty: boolean = true;
  public translation: ResultTranslation;

  private $unsubscribe: Subject<void> = new Subject();

  constructor(private resourcesService: ResourceManagerService) {
    this.resAsync = this.resourcesService.getResourceSet('abc-opath-queries-editor');
  }

  async ngOnInit(): Promise<void> {
    this.translation = {
      tableResult: (await this.resAsync).get('result-tableResult'),
      jsonResult: (await this.resAsync).get('result-jsonResult'),
      xmlResult: (await this.resAsync).get('result-xmlResult'),
      displayXmlQuery: (await this.resAsync).get('menu-showXMLQuery'),
      displayJsonQuery: (await this.resAsync).get('menu-showJSONQuery'),
      xmlPopUpMessage: (await this.resAsync).get('result-xml-popup-message'),
    };
  }

  public async refreshQueriesData(forceExecution: boolean = false): Promise<void> {
    if (this.autoExec || forceExecution) {
      this.resultsTableComponent?.refreshQueriesData();
      this.resultsJsonComponent?.refreshQueriesData();
      this.resultsXmlComponent?.refreshQueriesData();
    }
    this.resultsQueryXmlComponent?.refreshQueriesData();
    this.resultsQueryJsonComponent?.refreshQueriesData();
  }

  public refreshNestedGrid(): void {
    this.resultsTableComponent?.nestedGrid?.refreshNestedGrid();
  }

  public navigateTo(view: ResultsViews): void {
    this.currentView = view;
    setTimeout(() => {
      this.refreshQueriesData(this.autoExec);
    }, 0);
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
